module.exports = __webpack_public_path__ + "assets-cabinet/img/cancel.bf86a603.svg";